import { render, staticRenderFns } from "./SaveUser.vue?vue&type=template&id=2dfb866a"
import script from "./SaveUser.vue?vue&type=script&lang=js"
export * from "./SaveUser.vue?vue&type=script&lang=js"
import style0 from "./SaveUser.vue?vue&type=style&index=0&id=2dfb866a&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports